import {
  PatchChatDetectedChartingCredentialsRequestSchema,
  PatchChatDetectedChartingCredentialsResponseSchema,
} from "@clipboard-health/contract-backend-main";
import { patch } from "@src/appV2/api/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import {
  useMutation,
  type UseMutationOptions,
  type UseMutationResult,
} from "@tanstack/react-query";
import { type AxiosError } from "axios";
import type z from "zod";

type PatchChatDetectedChartingCredentialsRequest = z.input<
  typeof PatchChatDetectedChartingCredentialsRequestSchema
>;
type PatchChatDetectedChartingCredentialsResponse = z.input<
  typeof PatchChatDetectedChartingCredentialsResponseSchema
>;

export function useDismissChatDetectedChartingCredentials(
  options: UseMutationOptions<
    PatchChatDetectedChartingCredentialsResponse,
    AxiosError,
    PatchChatDetectedChartingCredentialsRequest
  > = {}
): UseMutationResult<
  PatchChatDetectedChartingCredentialsResponse,
  AxiosError,
  PatchChatDetectedChartingCredentialsRequest
> {
  const mutationOptions: UseMutationOptions<
    PatchChatDetectedChartingCredentialsResponse,
    AxiosError,
    PatchChatDetectedChartingCredentialsRequest
  > = {
    mutationFn: async (data: PatchChatDetectedChartingCredentialsRequest) => {
      const response = await patch({
        url: `${environmentConfig.REACT_APP_BASE_API_URL}/chat-detected-charting-credentials/${data.data.id}`,
        data,
        requestSchema: PatchChatDetectedChartingCredentialsRequestSchema,
        responseSchema: PatchChatDetectedChartingCredentialsResponseSchema,
      });

      return response.data;
    },
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.DISMISS_CHAT_DETECTED_CHARTING_CREDENTIALS_FAILURE,
    },
    ...options,
  };

  return useMutation(mutationOptions);
}
